"use client";
import { useEffect, useRef, useState } from "react";
import { useCookieConsent } from "@/context/CookieConsentContext";

export default function ParagraphAd() {
    const adRef = useRef(null);
    const { consent } = useCookieConsent();
    const [canRequestAds, setCanRequestAds] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const host = window.location.hostname;
        const isLocalhost =
            host === "localhost" ||
            host === "127.0.0.1" ||
            host === "::1" ||
            host.endsWith(".local");

        setCanRequestAds(
            process.env.NODE_ENV === "production" &&
                !isLocalhost &&
                !!consent?.ads
        );
    }, [consent?.ads]);

    useEffect(() => {
        if (!canRequestAds) return;

        const ad = adRef.current;
        if (!ad) return;

        const observer = new ResizeObserver(([entry]) => {
            const width = entry.contentRect.width;
            if (width <= 100) return;

            if (ad.getAttribute("data-loaded") === "true") {
                observer.disconnect();
                return;
            }

            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                ad.setAttribute("data-loaded", "true");
            } catch (e) {
                console.warn("AdSense push error", e);
            }

            observer.disconnect();
        });

        observer.observe(ad);
        return () => observer.disconnect();
    }, [canRequestAds]);

    if (!canRequestAds) return null;

    return (
        <div className="my-6 w-full flex justify-center">
            <ins
                ref={adRef}
                className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-9095963128435010"
                data-ad-slot="7271562266"
                data-ad-format="fluid"
                data-ad-layout="in-article"
            />
        </div>
    );
}
